import { useEffect } from "react";

const DEFAULT_DESC =
  "Centro Studi Forma Futuro — orientamento e percorsi di formazione: diplomi, lauree, corsi di formazione professionale e certificazioni linguistiche e informatiche.";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title
      ? `${title} | Centro Studi Forma Futuro`
      : "Centro Studi Forma Futuro";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description || DEFAULT_DESC);
  }, [title, description]);
}
